import { Serializable } from '@/models/core/serializable';
import i18n from '@/i18n';
import { GEnum } from '@/constants/enum.defination';

export class EvalSettingMail implements Serializable<EvalSettingMail> {
  ids: number[] = [];
  dates: Date[] = [];
  mailEnable: boolean = false;
  sendRegularly: boolean = true;
  sendRegularlyView: GEnum.RadioLabel = GEnum.RadioLabel.True

  deserialize(input: any): EvalSettingMail {
    if (input.ids != undefined && input.ids != null && input.ids.length > 0) {
      this.ids = input.ids;
    }
    
    if (input.dates != undefined && input.dates != null && input.dates.length > 0) {
      this.dates = input.dates.map((d: string) => {
        return new Date(d);
      });
    }
    this.mailEnable = input.mailEnable;
    
    if (input.sendRegularly !== undefined) {
      this.sendRegularly = input.sendRegularly;
      this.sendRegularlyView = this.sendRegularly ? GEnum.RadioLabel.True : GEnum.RadioLabel.False;
    }

    return this;
  }
}

export class EvalSettingMailToggleResponse implements Serializable<EvalSettingMailToggleResponse> {
  result: boolean = false;
  errType: number;

  deserialize(input: any): EvalSettingMailToggleResponse {
    this.result = input.result;
    this.errType = input.errType;

    return this;
  }
}
